export function stripPhone(value: string): string {
  return value.replace(/\D/g, '')
}

export function formatPhone(value?: string | null): string {
  if (!value) return ''
  const digits = stripPhone(value)
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  }
  if (digits.length > 11) {
    const countryCode = digits.slice(0, digits.length - 11)
    const local = digits.slice(-11)
    return `+${countryCode} (${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`
  }
  return value
}

export const PHONE_TYPES = ['phone', 'mobile', 'whatsapp']

export function formatContactValue(contact: {
  type: string
  value: string
}): string {
  if (PHONE_TYPES.includes(contact.type)) {
    return formatPhone(contact.value)
  }
  return contact.value
}
